<template>
    <div class="scheduled-content-item-wrapper" :class="{'is-header-title': isHeaderTitle}">
        <div>{{ contentLabel }}</div>
        <div>{{ newValue }}</div>
        <div>{{ scheduledFor }}</div>
        <confirmation-button
            v-if="isPermissionAllowed('schedule_content')"
            v-show="!isHeaderTitle"
            action-label="Remove Schedule Change"
            bootstrap-theme="danger"
            :max-width="200"
            @action-clicked="handleDeleteItem"
            class="delete-button">
        </confirmation-button>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import ConfirmationButton from '../generic/confirmation-button.vue';

let base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'scheduled-content-item',
    components: {
        ConfirmationButton
    },
    props: {
        isHeaderTitle: {
            type: Boolean,
            default: false,
        },
        itemDetails: {
            type: Object
        },
        availableVersions: {
            type: Array
        }
    },
    computed: {
        itemVersionName() {
            let versionName = "0";
            this.availableVersions.forEach(element => {
                if (element.id === this.itemDetails.version_id) {
                    versionName = element.name;
                }

            });
            return versionName;

        },
        contentLabel() {
            if (this.isHeaderTitle) {
                return 'Label (Version)';
            }
            return `${this.itemDetails.content_label} (${this.itemVersionName})`
        },
        newValue() {
            if (this.isHeaderTitle) {
                return 'Change';
            }
            let jBlob = JSON.parse(this.itemDetails.value);
            return jBlob.content;
        },
        scheduledFor() {
            if (this.isHeaderTitle) {
                return 'Scheduled Date (UTC)';
            }
            return moment(this.itemDetails.scheduled_to).format("MMM Do YY [at] LT");
        },
        checkedPermissions() {
            return this.$parent.$parent.$parent.$parent.enabledPermissions ? this.$parent.$parent.$parent.$parent.enabledPermissions : [];
        },
    },
    methods: {
        handleDeleteItem() {
            this.$emit("show-load-indicator");
            axios.delete(base_url + '/pimapi/scheduled-content/'+this.itemDetails.id)
            .then((response) => {
                this.$emit("hide-load-indicator");
                this.$emit("item-deleted");
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
        },
        isPermissionAllowed(str) {
            if(this.checkedPermissions === null || this.checkedPermissions === undefined || this.checkedPermissions.length == 0) {
                return;
            }
            return this.checkedPermissions.includes(str);
        },
    }
}
</script>

<style lang="scss">
.scheduled-content-item-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    column-gap: 10px;
    color: #333333;
    margin-top: 15px;
    margin-bottom: 15px;
    justify-items: start;
    align-items: center;
    .delete-button {
        width: 100%
    }
}
.is-header-title {
    border-bottom: solid 1px #dee2e6;
    color: #666666;
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 14px;
    font-weight: bold;
}

</style>
